/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Steps_CompactingInputs */



/**
* | output |
* | --- |
* | "Compacting conversation to fit the model..." |
*
* @param {Chat_Steps_CompactingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_compacting = /** @type {((inputs?: Chat_Steps_CompactingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_CompactingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konversation wird komprimiert...")
	return /** @type {LocalizedString} */ ("Compacting conversation to fit the model...")
});